import { ArrayParam, NumberParam, NumericArrayParam, StringParam, withDefault } from 'use-query-params';

export const statusColors = {
  ACCESSED: 'bg-success-50 text-success-500',
  PENDING: 'bg-progress-50 text-progress-500',
  REJECTED: 'bg-error-50 text-error-500'
};

export const statusDarkColors = {
  ACCESSED: 'bg-success-500 text-white',
  PENDING: 'bg-progress-500 text-white',
  REJECTED: 'bg-error-500 text-white'
};

export const queryKeys = {
  BOOKINGS: 'realtor-bookings',
  ONE_BOOKING: 'one-realtor-booking',
  BOOKING_COUNT: 'realtor-booking-count'
};

export const realtorQueryParams = {
  search: StringParam,
  page: withDefault(NumberParam, 1),
  size: withDefault(NumberParam, 10),
  startDate: StringParam,
  finishDate: StringParam,
  realtors: NumericArrayParam,
  houses: NumericArrayParam,
  buildings: NumericArrayParam,
  companies: NumericArrayParam,
  actions: ArrayParam
};
